import Button from '../atoms/Button';
import Spinner from '../atoms/Spinner';

/**
 * EmptyState — unified loading / error / empty / notFound block.
 *
 *   <EmptyState variant="loading" title="Memuat data…" />
 *   <EmptyState variant="error" title="Gagal memuat" hint={err.message}
 *               action={{ label: 'Coba Lagi', onClick: retry }} />
 *   <EmptyState title="Tidak ada data" hint="…" action={{ label: 'Reset Filter', onClick }} />
 *
 * `action` may also be an array of { label, onClick, variant, icon }.
 */
export default function EmptyState({
  variant = 'empty', // 'loading' | 'error' | 'empty' | 'notFound'
  icon: Icon,
  title,
  hint,
  action,
  children,
  className = '',
}) {
  const actions = action ? (Array.isArray(action) ? action : [action]) : [];

  return (
    <div className={`empty-state empty-state--${variant} ${className}`.trim()} role={variant === 'error' ? 'alert' : undefined}>
      {variant === 'loading' && <Spinner />}
      {variant !== 'loading' && Icon && (
        <span className="empty-state__icon">
          <Icon size={28} aria-hidden="true" />
        </span>
      )}
      {title && <div className="empty-state__title">{title}</div>}
      {hint && <div className="empty-state__hint">{hint}</div>}
      {children}
      {actions.length > 0 && (
        <div className="empty-state__actions">
          {actions.map((a) => (
            <Button
              key={a.label}
              variant={a.variant ?? 'secondary'}
              size="sm"
              icon={a.icon}
              onClick={a.onClick}
            >
              {a.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
